import { CommonModule } from "@angular/common";
import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { ToastMessageService } from '@k12/app-services';
import { ToastMessageType } from '@k12/models';
import { ToastMessage } from '@k12/models';
import { Subscription } from "rxjs";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MatButtonModule],
  selector: 'app-toast',
  styleUrl: './toast.component.scss',
  templateUrl: './toast.component.html'
})
export class ToastComponent implements OnInit, OnDestroy {
  public toastList: ToastMessage[] = [];
  public ToastType = ToastMessageType;
  public subscription?: Subscription;

  private readonly toastMessageService = inject(ToastMessageService);

  public ngOnInit(): void {
    // Internal Subject; cannot error by construction, so no error handler is needed.
    this.subscription = this.toastMessageService.showToast$.subscribe((toasts) => {
      this.toastList = toasts;
    });
  }

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  public hideToastMessage(toast: ToastMessage): void {
    this.toastMessageService.removeToast(toast.id);
  }

  public pauseToastTimer(toast: ToastMessage): void {
    this.toastMessageService.pauseToast(toast);
  }

  public resumeToastTimer(toast: ToastMessage): void {
    this.toastMessageService.resumeToast(toast);
  }
}
